import React from "react";
import "./skins.css";

function PayloadLine({ payload }) {
  if (!payload || typeof payload !== "object") {
    return <span className="event-payload-line">-</span>;
  }

  const entries = Object.entries(payload).slice(0, 4);
  return (
    <div className="event-payload-line">
      {entries.map(([key, value]) => (
        <span key={key}>{key}: {String(value)}</span>
      ))}
    </div>
  );
}

export default function EventTimelineSkin({ events = [], latestEvent }) {
  const displayEvents = latestEvent ? [latestEvent, ...events] : events;
  return (
    <section className="skin-card event-timeline-skin">
      <header className="skin-card__header">
        <h3>센서 이벤트</h3>
      </header>
      <div className="skin-card__body">
        {!displayEvents.length ? (
          <div className="skin-empty-inline">센서 이벤트가 없습니다.</div>
        ) : (
          <div className="timeline-list">
            {displayEvents.map((event, index) => (
              <article className="timeline-item" key={event.comment_id || event.id || index}>
                <div className="timeline-item__top">
                  <strong>{event.source_label || event.source || "-"}</strong>
                  <span>{event.created_at || event.received_at || "-"}</span>
                </div>
                <p>{event.summary || "-"}</p>
                <PayloadLine payload={event.payload} />
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
